import { Controller } from '@hotwired/stimulus';

export default class LivestreamModalController extends Controller {
  static targets = [
    'registrationInstructions',
    'confirmationMessage',
    'submitButton'
  ];

  get registrationInstructions() {
    return this.registrationInstructionsTarget;
  }

  get submitButton() {
    return this.submitButtonTarget;
  }

  get confirmationMessage() {
    return this.confirmationMessageTarget;
  }

  showConfirmationMessage() {
    this.confirmationMessage.classList.remove('hidden');
    this.confirmationMessage.classList.add('block');
  }

  hideRegistrationInstructions() {
    this.registrationInstructions.classList.remove('block');
    this.registrationInstructions.classList.add('hidden');
  }

  hideSubmitButton() {
    this.submitButton.classList.remove('block');
    this.submitButton.classList.add('hidden');
  }

  onRsvpSuccess() {
    setTimeout(() => this.showAsRegistered(), 0);
  }

  showAsRegistered() {
    this.showConfirmationMessage();
    this.hideSubmitButton();
    this.hideRegistrationInstructions();

    this.submitButton.disabled = true;
  }
}
